<section class="mb-sm-3">
  <div class="container-fluid py-2">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col">
        <div class="card shopping-cart" style="border-radius: 15px;">
          <div class="card-body">
            <div class="row" *ngIf="cartTotal > 0">
              <div class="col-xl-5 col-xs-12 px-3 py-2">
                <p class="mb-1 pt-2 fw-bold text-uppercase">Your cart</p>
                <div class="table table-responsive" *ngIf="cartTotal > 0">
                  <app-item [cartData]="cartData"></app-item>
                  <hr class="mb-3" style="height: 2px; background-color: #d73634; opacity: 1;">
                  <!--<div class="d-flex justify-content-between px-x">
                    <p class="fw-bold">Discount(s):</p>
                    <p class="fw-bold">{{cartDiscount | currency:"INR"}}</p>
                  </div>-->
                  <div class="d-flex justify-content-between p-2 mb-2 text-light bg-danger">
                    <h5 class="fw-bold mb-0">Total:</h5>
                    <h5 class="fw-bold mb-0">{{cartTotal | currency:"INR"}}</h5>
                  </div>
                </div>
              </div>
              <div class="col-xl-7" *ngIf="isLoggedIn">
                <div class="row">
                  <div class="col-xl-6 col-xs-12">
                    <app-addresses [activeOption]="'Select'" [limit]="5" (getAddressData)="getSelectedAddress($event)"></app-addresses>
                  </div>
                  <div class="col-xl-6  col-xs-12 px-3 py-2">
                    <p class="mb-4 pt-2 fw-bold text-uppercase">Payment Options</p>
                    <app-payment (selectedOption)="getPaymentMode($event)" (emiPlan)="getEMIPlan($event)"></app-payment>
                  </div>
                </div>
              </div>
              <div class="col-md-7" *ngIf="!isLoggedIn">
                <div class="checkout-area text-center">
                  <div class="no-data-container text-center">
                    <div class="card no-data-card shadow">
                      <div class="card-body h-100">
                        <h5 class="card-title text-danger">Checkout</h5>
                        <p class="card-text text-muted">You are not logged in. Login to proceed to checkout.</p>
                        <a role="button" [routerLink]="'/auth'"><button class="btn btn-sm btn-outline-danger">Login to checkout</button></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="cartTotal == 0">
              <div class="table table-responsive" *ngIf="cartTotal == 0">
                <div class="no-data-container text-center">
                  <div class="card no-data-card shadow">
                    <div class="card-body">
                      <h5 class="card-title text-danger">No Items in your cart</h5>
                      <p class="card-text text-muted">Try search or filters to find what you're looking for.</p>
                      <a role="button" [routerLink]="'/'"><button class="btn btn-sm btn-outline-danger">Continue Shopping</button></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
